module.exports = __webpack_public_path__ + "static/media/autumnleaf.2cf53c7e.webp";